import { z } from 'zod';
/** A followed meeting's kind (MT-1). */
export const MEETING_KINDS = ['Weekly review', 'Standup'];
const followedMeeting = z.object({
    meetingId: z.string(),
    title: z.string(),
    kind: z.enum(MEETING_KINDS),
    /** "Tuesdays, 9:30 AM" */
    schedule: z.string(),
    meetLink: z.string().nullable(),
    /** The projects it covers; empty when it covers all of them. */
    projects: z.array(z.object({ slug: z.string(), name: z.string() })),
    /** MTG-005: it covers every project. */
    allProjects: z.boolean(),
    /** "Tue 22 Sep"; null until Pulse has read its first notes. */
    lastNotesLabel: z.string().nullable(),
});
/** Meetings we follow (MT-1). */
export const followedMeetingsResponseSchema = z.object({
    meetings: z.array(followedMeeting),
    /** The projects a meeting can cover, for the form. */
    projects: z.array(z.object({ slug: z.string(), name: z.string() })),
});
const coverage = {
    projects: z.array(z.string().min(1)).default([]),
    /** MTG-005: covers every project, in place of picking them. */
    allProjects: z.boolean().default(false),
};
const pickedSome = (body) => body.allProjects || body.projects.length > 0;
const pickSome = { message: 'Pick at least one project the meeting covers, or All projects.', path: ['projects'] };
/** Following a meeting: its Meet link or title, its kind and the projects it covers. */
export const followMeetingBodySchema = z.object({
    query: z.string().trim().min(1, "Enter the meeting's Meet link or its title."),
    kind: z.enum(MEETING_KINDS),
    ...coverage,
}).refine(pickedSome, pickSome);
/** Changing a followed meeting's kind and projects. */
export const changeMeetingBodySchema = z.object({ kind: z.enum(MEETING_KINDS), ...coverage }).refine(pickedSome, pickSome);
/** A project's Meetings tab (MT-4): what each followed meeting said about the project, latest first. */
export const projectMeetingsResponseSchema = z.object({
    product: z.object({ slug: z.string(), name: z.string(), hasBoard: z.boolean(), hasStories: z.boolean() }),
    meetings: z.array(z.object({
        meetingId: z.string(),
        occurrenceId: z.string(),
        title: z.string(),
        kind: z.enum(MEETING_KINDS),
        /** "Fri 25 Sep, 3:00 AM" */
        whenLabel: z.string(),
        attendees: z.array(z.string()),
        /** True when the meeting covers several projects and Talos hasn't split its notes yet. */
        unsplit: z.boolean(),
        summary: z.string(),
        nextSteps: z.array(z.string()),
        /** Talos's reading for this project, when it has written one. */
        talos: z.string().nullable(),
        /** A date change Talos heard agreed, waiting on a member (MT-3). */
        change: z
            .object({
            milestoneId: z.string(),
            milestoneTitle: z.string(),
            fromLabel: z.string(),
            toLabel: z.string(),
            decision: z.enum(['pending', 'accepted', 'dismissed']),
        })
            .nullable(),
    })),
});
/** Accepting or dismissing a proposed date change (MT-3). */
export const dateChangeDecisionBodySchema = z.object({
    meetingId: z.string().min(1),
    occurrenceId: z.string().min(1),
    project: z.string().min(1),
    decision: z.enum(['accept', 'dismiss']),
});
//# sourceMappingURL=meetings.js.map